module.exports = __webpack_public_path__ + "img/on_reco_logo.b9053ade.png";